// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   TextField,
//   DialogActions,
//   IconButton,
//   DialogContentText,
// } from "@mui/material";
// import { useSelector, useDispatch } from "react-redux";
// import {
//   changeInterviewStatus,
//   changeJobApplicationStatus,
//   deleteRond,
//   getApplicants,
//   getApplicationStatusHistory,
//   getInterviewRounds,
// } from "../../../../Redux/Reducers/JobReducer";
// import InsertLinkRoundedIcon from "@mui/icons-material/InsertLinkRounded";
// import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
// import InterviewScheduleSlider from "../InterviewScheduleSlider";
// import EditRoundedIcon from "@mui/icons-material/EditRounded";
// import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
// import AssignmentModal from "./AssignmentModal";

// const SelectionModal = ({ open, onClose, remarks, setRemarks, onConfirm }) => (
//   <Dialog open={open} onClose={onClose}>
//     <DialogTitle>Confirm Selection</DialogTitle>
//     <DialogContent sx={{ width: "600px" }}>
//       <TextField
//         autoFocus
//         margin="dense"
//         label="Write remark for selection"
//         fullWidth
//         multiline
//         rows={4}
//         value={remarks}
//         onChange={(e) => setRemarks(e.target.value)}
//       />
//     </DialogContent>
//     <DialogActions>
//       <Button onClick={onClose} color="primary">
//         Cancel
//       </Button>
//       <Button onClick={onConfirm} color="primary" variant="contained">
//         Confirm
//       </Button>
//     </DialogActions>
//   </Dialog>
// );

// const SelectModal = ({ open, onClose, remarks, setRemarks, onConfirm }) => (
//   <Dialog open={open} onClose={onClose}>
//     <DialogTitle>Confirm Selection</DialogTitle>
//     <DialogContent sx={{ width: "600px" }}>
//       <TextField
//         autoFocus
//         margin="dense"
//         label="Write remark for selection"
//         fullWidth
//         multiline
//         rows={4}
//         value={remarks}
//         onChange={(e) => setRemarks(e.target.value)}
//       />
//     </DialogContent>
//     <DialogActions>
//       <Button onClick={onClose} color="primary">
//         Cancel
//       </Button>
//       <Button onClick={onConfirm} color="primary" variant="contained">
//         Confirm
//       </Button>
//     </DialogActions>
//   </Dialog>
// );

// const RejectionModal = ({ open, onClose, remarks, setRemarks, onConfirm }) => (
//   <Dialog open={open} onClose={onClose}>
//     <DialogTitle>Confirm Rejection</DialogTitle>
//     <DialogContent sx={{ width: "600px" }}>
//       <TextField
//         autoFocus
//         margin="dense"
//         label="Write remark for rejection"
//         fullWidth
//         multiline
//         rows={4}
//         value={remarks}
//         onChange={(e) => setRemarks(e.target.value)}
//       />
//     </DialogContent>
//     <DialogActions>
//       <Button onClick={onClose} color="primary">
//         Cancel
//       </Button>
//       <Button onClick={onConfirm} color="error" variant="contained">
//         Confirm
//       </Button>
//     </DialogActions>
//   </Dialog>
// );

// const DeleteConfirmationDialog = ({ open, onClose, onConfirm }) => (
//   <Dialog open={open} onClose={onClose}>
//     <DialogTitle>Confirm Delete</DialogTitle>
//     <DialogContent>
//       <DialogContentText>
//         Are you sure you want to delete this round? This action cannot be
//         undone.
//       </DialogContentText>
//     </DialogContent>
//     <DialogActions>
//       <Button onClick={onClose} color="primary">
//         Cancel
//       </Button>
//       <Button onClick={onConfirm} color="error" variant="contained">
//         Delete
//       </Button>
//     </DialogActions>
//   </Dialog>
// );

// const InterviewRoundsList = ({ candidateId, applicant }) => {
//   const dispatch = useDispatch();
//   const [rounds, setRounds] = useState([]);
//   const [openSelectModal, setOpenSelectModal] = useState(false);
//   const [openRejectModal, setOpenRejectModal] = useState(false);
//   const [remarks, setRemarks] = useState("");
//   const [selectedRoundCode, setSelectedRoundCode] = useState(null);
//   const [selectedAssignment, setSelectedAssignment] = useState(null);
//   const [openPdf, setPdfOpen] = useState(false);
//   const [editingRound, setEditingRound] = useState(null);
//   const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
//   const [openDelete, setOpenDelete] = useState(false);
//   const [viewType, setViewType] = useState("");

//   const Jobs = useSelector((state) => state?.jobs?.postedJobsData) || {};
//   const postedJobs = Jobs?.posted_jobs;
//   const InterviewRoundsRes = useSelector(
//     (state) => state?.jobs?.interviewRounds
//   ) || [];

//   const getNoOfRounds = (applicant, postedJobs) => {
//     const job = postedJobs?.find((job) => job?.id === applicant?.job_id);
//     return job ? job?.no_of_rounds : null;
//   };

//   useEffect(() => {
//     const totalRounds = getNoOfRounds(applicant, postedJobs);
//     if (totalRounds) {
//       const completedRoundsCount = InterviewRoundsRes?.length || 0;
//       const totalRoundsToShow = Math.max(totalRounds, completedRoundsCount);

//       const initialRounds = Array.from(
//         { length: totalRoundsToShow },
//         (_, index) => ({
//           id: index + 1,
//           name: `Round ${index + 1}`,
//           type: "Not Scheduled",
//           scheduled: false,
//           status: "Pending",
//         })
//       );

//       const updatedRounds = initialRounds?.map((round, index) => {
//         const completedRound = InterviewRoundsRes[index];
//         return completedRound
//           ? { ...round, ...completedRound, scheduled: true }
//           : round;
//       });

//       setRounds(updatedRounds);
//     }
//   }, [InterviewRoundsRes, applicant, postedJobs]);

//   useEffect(() => {
//     if (candidateId) {
//       dispatch(getInterviewRounds(candidateId));
//     }
//   }, [candidateId, dispatch]);

//   const handleSelect = (roundCode) => {
//     setSelectedRoundCode(roundCode);
//     setOpenSelectModal(true);
//   };

//   const handleReject = (roundCode) => {
//     setSelectedRoundCode(roundCode);
//     setOpenRejectModal(true);
//   };

//   const handleConfirmSelect = () => {
//     dispatch(
//       changeInterviewStatus({
//         round_code: selectedRoundCode,
//         selection_status: "Selected",
//         remarks: remarks,
//       })
//     ).then(() => {
//       setRounds((prev) =>
//         prev.map((round) =>
//           round.round_code === selectedRoundCode
//             ? { ...round, status: "Completed", selection_status: "Selected" }
//             : round
//         )
//       );
//       setOpenSelectModal(false);
//       setRemarks("");
//     });
//   };

//   const handleConfirmReject = () => {
//     dispatch(
//       changeInterviewStatus({
//         round_code: selectedRoundCode,
//         selection_status: "Rejected",
//         remarks: remarks,
//       })
//     );
//     setOpenRejectModal(false);
//     setRemarks("");
//   };

//   const handleScheduleClick = (roundToEdit = null) => {
//     setEditingRound(roundToEdit);
//     setScheduleModalOpen(true);
//   };

//   const handleDeleteRound = (roundCode) => {
//     setSelectedRoundCode(roundCode);
//     setOpenDelete(true);
//   };

//   const handleConfirmDelete = async () => {
//     try {
//       await dispatch(deleteRond(selectedRoundCode));
//       dispatch(getInterviewRounds(candidateId));
//       setOpenDelete(false);
//     } catch (error) {
//       console.error("Delete round failed:", error);
//     }
//   };

//   const handleViewDoc = (round, type) => {
//     setSelectedAssignment(round);
//     setViewType(type);
//     setPdfOpen(true);
//   };

//   const handleFinalInterviewed = async () => {
//     const payload = {
//       application_id: applicant?.application_id,
//       status: "Selected",
//       remarks: remarks || "Candidate completed all rounds successfully",
//     };

//     try {
//       await dispatch(changeJobApplicationStatus(payload));
//       await Promise.all([
//         dispatch(getApplicants({ job_id: applicant?.job_id })),
//         dispatch(
//           getApplicationStatusHistory({ id: applicant?.application_id })
//         ),
//       ]);
//       setOpenSelectModal(false);
//       setRemarks("");
//     } catch (error) {
//       console.error("Error updating status:", error);
//     }
//   };

//   const isPreviousRoundSelected = (rounds, currentIndex) => {
//     if (currentIndex === 0) return true;
//     return rounds[currentIndex - 1]?.selection_status === "Selected";
//   };

//   const allRoundsSelected =
//     rounds?.length > 0 &&
//     rounds.every(
//       (round) => !round.scheduled || round.selection_status === "Selected"
//     );

//   const RoundCard = ({ round, index }) => {
//     const currentTime = new Date();
//     const cutoffTime =
//       round.type === "Assignment"
//         ? new Date(round.deadline)
//         : round.interview_schedule?.end_time
//         ? new Date(round.interview_schedule.end_time)
//         : new Date();

//     const isTimeEnded = currentTime > cutoffTime;
//     const isActive = isPreviousRoundSelected(rounds, index);
//     const showActionButtons =
//       round.scheduled && !round.selection_status && isTimeEnded;

//     return (
//       <Box
//         sx={{
//           mb: 2,
//           p: 2,
//           borderRadius: "8px",
//           border: "1px solid #e0e0e0",
//           backgroundColor: round.scheduled ? "#f5f5f5" : "#E3F2FD",
//           opacity: isActive ? 1 : 0.7,
//           transition: "all 0.3s ease",
//           "&:hover": {
//             boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//             borderColor: "#0044C6",
//           },
//         }}
//       >
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             gap: 1,
//           }}
//         >
//           <Typography variant="subtitle1" fontWeight="bold" color="#0044C6">
//             {round.name}
//           </Typography>
//           <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//             {round.selection_status && (
//               <Typography
//                 sx={{
//                   color:
//                     round.selection_status === "Selected" ? "green" : "red",
//                 }}
//               >
//                 {round.selection_status}
//               </Typography>
//             )}
//             {round.scheduled &&
//               !round.selection_status &&
//               !openDelete &&
//               !showActionButtons && (
//                 <>
//                   <IconButton
//                     onClick={() => handleScheduleClick(round)}
//                     size="small"
//                     disabled={!isActive}
//                   >
//                     <EditRoundedIcon fontSize="small" />
//                   </IconButton>
//                   <IconButton
//                     onClick={() => handleDeleteRound(round.round_code)}
//                     size="small"
//                     disabled={!isActive}
//                   >
//                     <DeleteRoundedIcon fontSize="small" />
//                   </IconButton>
//                 </>
//               )}
//           </Box>
//         </Box>

//         <Typography variant="body2" sx={{ color: "#666", mt: 0.5 }}>
//           Type: {round.type === "F2F" ? "Face to Face" : round.type}
//         </Typography>

//         {round.scheduled && (
//           <RoundDetails round={round} handleViewDoc={handleViewDoc} />
//         )}

//         {showActionButtons && (
//           <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
//             <Button
//               variant="contained"
//               fullWidth
//               color="error"
//               onClick={() => handleReject(round.round_code)}
//               disabled={!isActive}
//             >
//               Reject
//             </Button>
//             <Button
//               variant="contained"
//               fullWidth
//               sx={{ bgcolor: "#0044C6" }}
//               onClick={() => handleSelect(round.round_code)}
//               disabled={!isActive}
//             >
//               Select
//             </Button>
//           </Box>
//         )}

//         {!round.scheduled && (
//           <Button
//             variant="contained"
//             fullWidth
//             sx={{ mt: 2, bgcolor: "#0044C6" }}
//             onClick={() => handleScheduleClick()}
//           >
//             Schedule Round
//           </Button>
//         )}
//       </Box>
//     );
//   };

//   return (
//     <Box sx={{ width: "100%", maxWidth: 800, mx: "auto", p: 1 }}>
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           mb: 3,
//         }}
//       >
//         <Typography variant="h6">Interview Rounds</Typography>
//         {allRoundsSelected && rounds?.some((round) => round.scheduled) && (
//           <>
//             <Button variant="outlined" onClick={() => setOpenSelectModal(true)}>
//               Mark as Interviewed
//             </Button>
//             <SelectModal
//               open={openSelectModal}
//               onClose={() => setOpenSelectModal(false)}
//               remarks={remarks}
//               setRemarks={setRemarks}
//               onConfirm={handleFinalInterviewed}
//             />
//           </>
//         )}
//       </Box>

//       <Box sx={{ flex: 1, overflowY: "auto", px: 1 }}>
//         {rounds?.map((round, index) => (
//           <RoundCard key={round?.id} round={round} index={index} />
//         ))}
//       </Box>

//       <Button
//         variant="contained"
//         fullWidth
//         sx={{ bgcolor: "#0044C6" }}
//         onClick={() => handleScheduleClick()} // Pass no argument for new round
//         disabled={
//           rounds?.length > 0 && !rounds[rounds?.length - 1]?.selection_status
//         }
//       >
//         {rounds?.length === 0
//           ? "Add First Interview Round"
//           : "Add New Interview Round"}
//       </Button>

//       <SelectionModal
//         open={openSelectModal}
//         onClose={() => setOpenSelectModal(false)}
//         remarks={remarks}
//         setRemarks={setRemarks}
//         onConfirm={handleFinalInterviewed}
//       />

//       <RejectionModal
//         open={openRejectModal}
//         onClose={() => setOpenRejectModal(false)}
//         remarks={remarks}
//         setRemarks={setRemarks}
//         onConfirm={handleConfirmReject}
//       />

//       <DeleteConfirmationDialog
//         open={openDelete}
//         onClose={() => setOpenDelete(false)}
//         onConfirm={handleConfirmDelete}
//       />

//       <AssignmentModal
//         viewType={viewType}
//         openPdf={openPdf}
//         onClose={() => setPdfOpen(false)}
//         application_id={selectedAssignment?.application_id}
//         assignment_file={selectedAssignment?.assignment_file}
//         assignment_file_type={selectedAssignment?.assignment_file_type}
//         submission_file={selectedAssignment?.submission_file}
//         submission_file_type={selectedAssignment?.submission_file_type}
//       />

//       <InterviewScheduleSlider
//         open={scheduleModalOpen}
//         onClose={() => setScheduleModalOpen(false)}
//         candidateId={candidateId}
//         existingRound={editingRound?.round_code}
//         isEditMode={!!editingRound}
//         applicant={applicant}
//       />
//     </Box>
//   );
// };

// const RoundDetails = ({ round, handleViewDoc }) => (
//   <>
//     {round.type === "F2F" && round.interview_schedule && (
//       <>
//         <Typography variant="body2" sx={{ color: "#666", mt: 1 }}>
//           Date:{" "}
//           {new Date(round.interview_schedule.start_time).toLocaleDateString()}
//         </Typography>
//         <Typography variant="body2" sx={{ color: "#666" }}>
//           Time:{" "}
//           {new Date(round.interview_schedule.start_time).toLocaleTimeString()} -
//           {new Date(round.interview_schedule.end_time).toLocaleTimeString()}
//         </Typography>
//         <Typography variant="body2" sx={{ color: "#666", mt: 0.5 }}>
//           Location: {round.interview_location}
//         </Typography>
//         <Typography variant="body2" sx={{ color: "#666", mt: 0.5 }}>
//           Description: {round?.description}
//         </Typography>

//         {round?.interviewers_list && (
//           <Box sx={{ mt: 2, borderTop: "1px solid #eee", pt: 2 }}>
//             <Typography
//               variant="body2"
//               sx={{ color: "#666", fontWeight: "bold", mb: 1 }}
//             >
//               Interviewer Details:
//             </Typography>
//             {round?.interviewers_list?.map((interviewer, idx) => (
//               <Box
//                 key={idx}
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 2,
//                   mb: 1,
//                   p: 1,
//                   borderRadius: "4px",
//                   backgroundColor: "rgba(0, 68, 198, 0.05)",
//                 }}
//               >
//                 <Box
//                   component="img"
//                   src={
//                     interviewer?.profile_url ||
//                     "https://static.vecteezy.com/system/resources/thumbnails/009/734/564/small_2x/default-avatar-profile-icon-of-social-media-user-vector.jpg"
//                   }
//                   alt={`${interviewer?.first_name}'s profile`}
//                   sx={{
//                     width: 40,
//                     height: 40,
//                     borderRadius: "50%",
//                     objectFit: "cover",
//                   }}
//                 />
//                 <Box>
//                   <Typography variant="body2" sx={{ fontWeight: "bold" }}>
//                     {interviewer?.first_name || "User"} {interviewer?.last_name}
//                   </Typography>
//                   <Typography variant="caption" sx={{ color: "#666" }}>
//                     {interviewer?.designation}
//                   </Typography>
//                 </Box>
//               </Box>
//             ))}
//           </Box>
//         )}
//       </>
//     )}

//     {round.type === "Remote" && round.interview_schedule && (
//       <>
//         <Typography variant="body2" sx={{ color: "#666", mt: 1 }}>
//           Date:{" "}
//           {new Date(round.interview_schedule.start_time).toLocaleDateString()}
//         </Typography>
//         <Typography variant="body2" sx={{ color: "#666" }}>
//           Time:{" "}
//           {new Date(round.interview_schedule.start_time).toLocaleTimeString()} -
//           {new Date(round.interview_schedule.end_time).toLocaleTimeString()}
//         </Typography>
//         <Typography
//           component="a"
//           href={round.interview_schedule.meet_link}
//           target="_blank"
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             color: "#0044C6",
//             mt: 1,
//           }}
//         >
//           <InsertLinkRoundedIcon sx={{ mr: 0.5 }} /> Join Meeting
//         </Typography>

//         {round?.interviewers_list && (
//           <Box sx={{ mt: 2, mb: 2, borderTop: "1px solid #eee", pt: 2 }}>
//             <Typography
//               variant="body2"
//               sx={{ color: "#666", fontWeight: "bold", mb: 1 }}
//             >
//               Interviewer Details:
//             </Typography>
//             {round?.interviewers_list?.map((interviewer, idx) => (
//               <Box
//                 key={idx}
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 2,
//                   mb: 1,
//                   p: 1,
//                   borderRadius: "4px",
//                   backgroundColor: "rgba(0, 68, 198, 0.05)",
//                 }}
//               >
//                 <Box
//                   component="img"
//                   src={
//                     interviewer?.profile_url ||
//                     "https://static.vecteezy.com/system/resources/thumbnails/009/734/564/small_2x/default-avatar-profile-icon-of-social-media-user-vector.jpg"
//                   }
//                   alt={`${interviewer?.first_name}'s profile`}
//                   sx={{
//                     width: 40,
//                     height: 40,
//                     borderRadius: "50%",
//                     objectFit: "cover",
//                   }}
//                 />
//                 <Box>
//                   <Typography variant="body2" sx={{ fontWeight: "bold" }}>
//                     {interviewer?.first_name || "User"} {interviewer?.last_name}
//                   </Typography>
//                   <Typography variant="caption" sx={{ color: "#666" }}>
//                     {interviewer?.designation}
//                   </Typography>
//                 </Box>
//               </Box>
//             ))}
//           </Box>
//         )}
//         <Typography
//           component="a"
//           href={round?.interview_schedule?.meet_link}
//           target="_blank"
//           sx={{
//             mt: 1,
//             display: "flex",
//             alignItems: "center",
//             cursor: "pointer",
//             textDecoration: "none",
//             color: "#0044C6",
//             "&:hover": { color: "#003399" },
//           }}
//         >
//           <InsertLinkRoundedIcon
//             sx={{ color: "#0044C6", marginRight: "5px" }}
//           />
//           Join Zoom Meeting
//         </Typography>
//       </>
//     )}

//     {round?.type === "Assignment" && (
//       <>
//         <Typography variant="body2" sx={{ color: "#666", mt: 1 }}>
//           Deadline:{" "}
//           {round?.deadline
//             ? new Date(round?.deadline).toLocaleString()
//             : "No deadline set"}
//         </Typography>
//         {round?.description && (
//           <Typography variant="body2" sx={{ color: "#666", mt: 0.5 }}>
//             Description: {round?.description}
//           </Typography>
//         )}
//         {round.assignment_file_type === "application/pdf" ||
//         round.assignment_file_type?.startsWith("image/") ? (
//           <Typography
//             component="a"
//             href={round.assignment_file}
//             onClick={(e) => {
//               e.preventDefault();
//               handleViewDoc(round, "Assignment");
//             }}
//             sx={{
//               mt: 1,
//               display: "flex",
//               alignItems: "center",
//               cursor: "pointer",
//               textDecoration: "none",
//               color: "#0044C6",
//               "&:hover": { color: "#003399" },
//             }}
//           >
//             <AssignmentRoundedIcon
//               sx={{ color: "#0044C6", marginRight: "5px" }}
//             />
//             View Assignment
//           </Typography>
//         ) : (
//           <Typography
//             component="a"
//             href={round.assignment_file}
//             target="_blank"
//             rel="noopener noreferrer"
//             sx={{
//               mt: 1,
//               display: "flex",
//               alignItems: "center",
//               cursor: "pointer",
//               textDecoration: "none",
//               color: "#0044C6",
//               "&:hover": { color: "#003399" },
//             }}
//           >
//             <AssignmentRoundedIcon
//               sx={{ color: "#0044C6", marginRight: "5px" }}
//             />
//             Check Assignment
//           </Typography>
//         )}
//       </>
//     )}
//     <hr />
//     {round?.submission_file &&
//       (round?.submission_file_type === "application/pdf" ||
//       round?.submission_file_type?.startsWith("image/") ? (
//         <Typography
//           component="a"
//           href={round?.submission_file}
//           onClick={(e) => {
//             e.preventDefault();
//             handleViewDoc(round, "submission");
//           }}
//           sx={{
//             mt: 1,
//             display: "flex",
//             alignItems: "center",
//             cursor: "pointer",
//             textDecoration: "none",
//             color: "#0044C6",
//             "&:hover": { color: "#003399" },
//           }}
//         >
//           View Submission
//         </Typography>
//       ) : (
//         <Typography
//           component="a"
//           href={round?.submission_file}
//           target="_blank"
//           sx={{
//             mt: 1,
//             display: "flex",
//             alignItems: "center",
//             cursor: "pointer",
//             textDecoration: "none",
//             color: "#0044C6",
//             "&:hover": { color: "#003399" },
//           }}
//         >
//           <AssignmentRoundedIcon
//             sx={{ color: "#0044C6", marginRight: "5px" }}
//           />
//           Download Assignment
//         </Typography>
//       ))}
//   </>
// );

// export default InterviewRoundsList;


import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  IconButton,
  DialogContentText,
  Avatar,
  Tooltip,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import {
  changeInterviewStatus,
  changeJobApplicationStatus,
  deleteRond,
  getApplicants,
  getApplicationStatusHistory,
  getInterviewRounds,
  interviewBusyShedule,
} from "../../../../Redux/Reducers/JobReducer";
import InsertLinkRoundedIcon from "@mui/icons-material/InsertLinkRounded";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import InterviewScheduleSlider from "../InterviewScheduleSlider";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import AssignmentModal from "./AssignmentModal";
import dayjs from "dayjs";

// Add BusySlotModal component (copied from InterviewScheduleSlider)
const BusySlotModal = ({ open, onClose, slots, date, onScheduleAnyway }) => {
  const mergeOverlappingSlots = (slots) => {
    const interviewerSlots = slots.reduce((acc, slot) => {
      const email = slot.interviewer.email;
      if (!acc[email]) {
        acc[email] = {
          interviewer: slot.interviewer,
          slots: [],
        };
      }
      acc[email].slots.push({ start: dayjs(slot.start), end: dayjs(slot.end) });
      return acc;
    }, {});

    const mergedSlots = Object.values(interviewerSlots).map(
      ({ interviewer, slots }) => {
        const sortedSlots = slots.sort(
          (a, b) => a.start.valueOf() - b.start.valueOf()
        );

        const mergedTimes = sortedSlots.reduce((merged, current) => {
          if (
            !merged.length ||
            merged[merged.length - 1].end.isBefore(current.start)
          ) {
            merged.push(current);
          } else {
            const lastMerged = merged[merged.length - 1];
            lastMerged.end = lastMerged.end.isAfter(current.end)
              ? lastMerged.end
              : current.end;
          }
          return merged;
        }, []);

        return {
          interviewer,
          timeSlots: mergedTimes,
        };
      }
    );

    return mergedSlots;
  };

  const consolidatedSlots = mergeOverlappingSlots(slots);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Busy Schedule for {dayjs(date).format("MMMM D, YYYY")} at{" "}
        {dayjs(date).format("hh:mm A")}
      </DialogTitle>
      <DialogContent>
        <Typography color="error" gutterBottom>
          The following interviewers are busy during this time slot:
        </Typography>
        {consolidatedSlots.map((interviewerData, index) => (
          <Box
            key={index}
            sx={{ mb: 2, p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}
          >
            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
              <Avatar
                src={interviewerData.interviewer.avatar}
                alt={interviewerData.interviewer.name}
                sx={{ mr: 1, width: 32, height: 32 }}
              />
              <Box>
                <Typography variant="subtitle2">
                  {interviewerData.interviewer.name}
                </Typography>
                <Typography variant="caption">
                  {interviewerData.interviewer.email}
                </Typography>
              </Box>
            </Box>
            {interviewerData.timeSlots.map((timeSlot, idx) => (
              <Typography key={idx} variant="body2">
                Busy from {timeSlot.start.format("h:mm A")} to{" "}
                {timeSlot.end.format("h:mm A")}
              </Typography>
            ))}
          </Box>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Choose Different Time</Button>
        <Button onClick={onScheduleAnyway} variant="contained" color="warning">
          Schedule Anyway
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const SelectionModal = ({ open, onClose, remarks, setRemarks, onConfirm }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Confirm Selection</DialogTitle>
    <DialogContent sx={{ width: "600px" }}>
      <TextField
        autoFocus
        margin="dense"
        label="Write remark for selection"
        fullWidth
        multiline
        rows={4}
        value={remarks}
        onChange={(e) => setRemarks(e.target.value)}
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary">
        Cancel
      </Button>
      <Button onClick={onConfirm} color="primary" variant="contained">
        Confirm
      </Button>
    </DialogActions>
  </Dialog>
);

const SelectModal = ({ open, onClose, remarks, setRemarks, onConfirm }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Confirm Selection</DialogTitle>
    <DialogContent sx={{ width: "600px" }}>
      <TextField
        autoFocus
        margin="dense"
        label="Write remark for selection"
        fullWidth
        multiline
        rows={4}
        value={remarks}
        onChange={(e) => setRemarks(e.target.value)}
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary">
        Cancel
      </Button>
      <Button onClick={onConfirm} color="primary" variant="contained">
        Confirm
      </Button>
    </DialogActions>
  </Dialog>
);

const RejectionModal = ({ open, onClose, remarks, setRemarks, onConfirm }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Confirm Rejection</DialogTitle>
    <DialogContent sx={{ width: "600px" }}>
      <TextField
        autoFocus
        margin="dense"
        label="Write remark for rejection"
        fullWidth
        multiline
        rows={4}
        value={remarks}
        onChange={(e) => setRemarks(e.target.value)}
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary">
        Cancel
      </Button>
      <Button onClick={onConfirm} color="error" variant="contained">
        Confirm
      </Button>
    </DialogActions>
  </Dialog>
);

const DeleteConfirmationDialog = ({ open, onClose, onConfirm }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Confirm Delete</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Are you sure you want to delete this round? This action cannot be
        undone.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary">
        Cancel
      </Button>
      <Button onClick={onConfirm} color="error" variant="contained">
        Delete
      </Button>
    </DialogActions>
  </Dialog>
);

// const InterviewRoundsList = ({ candidateId, applicant }) => {
//   const dispatch = useDispatch();
//   const [rounds, setRounds] = useState([]);
//   const [openSelectModal, setOpenSelectModal] = useState(false);
//   const [openRejectModal, setOpenRejectModal] = useState(false);
//   const [remarks, setRemarks] = useState("");
//   const [selectedRoundCode, setSelectedRoundCode] = useState(null);
//   const [selectedAssignment, setSelectedAssignment] = useState(null);
//   const [openPdf, setPdfOpen] = useState(false);
//   const [editingRound, setEditingRound] = useState(null);
//   const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
//   const [openDelete, setOpenDelete] = useState(false);
//   const [viewType, setViewType] = useState("");

//   // Add busy slots state
//   const [showBusySlotModal, setShowBusySlotModal] = useState(false);
//   const [selectedDateBusySlots, setSelectedDateBusySlots] = useState([]);
//   const [selectedDate, setSelectedDate] = useState(null);
//   const interviewers = useSelector((state) => state?.jobs?.interviewers?.interviewers) || [];
//   const Jobs = useSelector((state) => state?.jobs?.postedJobsData) || {};
//   const postedJobs = Jobs?.posted_jobs;
//   const InterviewRoundsRes = useSelector(
//     (state) => state?.jobs?.interviewRounds
//   ) || [];

//   // Add busy slots selector
//   const interviewersbusyslots = useSelector((state) => state?.jobs?.interviewersbusyslots) || {};

//   const getNoOfRounds = (applicant, postedJobs) => {
//     const job = postedJobs?.find((job) => job?.id === applicant?.job_id);
//     return job ? job?.no_of_rounds : null;
//   };

//   useEffect(() => {
//     const totalRounds = getNoOfRounds(applicant, postedJobs);
//     if (totalRounds) {
//       const completedRoundsCount = InterviewRoundsRes?.length || 0;
//       const totalRoundsToShow = Math.max(totalRounds, completedRoundsCount);

//       const initialRounds = Array.from(
//         { length: totalRoundsToShow },
//         (_, index) => ({
//           id: index + 1,
//           name: `Round ${index + 1}`,
//           type: "Not Scheduled",
//           scheduled: false,
//           status: "Pending",
//         })
//       );

//       const updatedRounds = initialRounds?.map((round, index) => {
//         const completedRound = InterviewRoundsRes[index];
//         return completedRound
//           ? { ...round, ...completedRound, scheduled: true }
//           : round;
//       });

//       setRounds(updatedRounds);
//     }
//   }, [InterviewRoundsRes, applicant, postedJobs]);

//   useEffect(() => {
//     if (candidateId) {
//       dispatch(getInterviewRounds(candidateId));
//     }
//   }, [candidateId, dispatch]);

//   // Add busy slots detection function (from InterviewScheduleSlider)
//   const getBusySlots = (date) => {
//     if (!interviewersbusyslots || !date) return [];

//     const dateStr = dayjs(date).format("YYYY-MM-DD");
//     const busySlots = [];

//     Object.entries(interviewersbusyslots).forEach(([email, slots]) => {
//       const interviewer = interviewers?.find((i) => i.email === email);
//       slots.forEach((slot) => {
//         const slotDate = dayjs(slot.start).format("YYYY-MM-DD");
//         if (slotDate === dateStr) {
//           busySlots.push({
//             interviewer: {
//               name: `${interviewer?.first_name} ${interviewer?.last_name}`,
//               email,
//               avatar: interviewer?.profile_url,
//             },
//             start: dayjs(slot.start),
//             end: dayjs(slot.end),
//           });
//         }
//       });
//     });

//     return busySlots.sort((a, b) => a.start.valueOf() - b.start.valueOf());
//   };

//   const handleSelect = (roundCode) => {
//     setSelectedRoundCode(roundCode);
//     setOpenSelectModal(true);
//   };

//   const handleReject = (roundCode) => {
//     setSelectedRoundCode(roundCode);
//     setOpenRejectModal(true);
//   };

//   const handleConfirmSelect = () => {
//     dispatch(
//       changeInterviewStatus({
//         round_code: selectedRoundCode,
//         selection_status: "Selected",
//         remarks: remarks,
//       })
//     ).then(() => {
//       setRounds((prev) =>
//         prev.map((round) =>
//           round.round_code === selectedRoundCode
//             ? { ...round, status: "Completed", selection_status: "Selected" }
//             : round
//         )
//       );
//       setOpenSelectModal(false);
//       setRemarks("");
//     });
//   };

//   const handleConfirmReject = () => {
//     dispatch(
//       changeInterviewStatus({
//         round_code: selectedRoundCode,
//         selection_status: "Rejected",
//         remarks: remarks,
//       })
//     );
//     setOpenRejectModal(false);
//     setRemarks("");
//   };

//   const handleScheduleClick = (roundToEdit = null) => {
//     setEditingRound(roundToEdit);
//     setScheduleModalOpen(true);
//   };

//   const handleDeleteRound = (roundCode) => {
//     setSelectedRoundCode(roundCode);
//     setOpenDelete(true);
//   };

//   const handleConfirmDelete = async () => {
//     try {
//       await dispatch(deleteRond(selectedRoundCode));
//       dispatch(getInterviewRounds(candidateId));
//       setOpenDelete(false);
//     } catch (error) {
//       console.error("Delete round failed:", error);
//     }
//   };

//   const handleViewDoc = (round, type) => {
//     setSelectedAssignment(round);
//     setViewType(type);
//     setPdfOpen(true);
//   };

//   const handleFinalInterviewed = async () => {
//     const payload = {
//       application_id: applicant?.application_id,
//       status: "Selected",
//       remarks: remarks || "Candidate completed all rounds successfully",
//     };

//     try {
//       await dispatch(changeJobApplicationStatus(payload));
//       await Promise.all([
//         dispatch(getApplicants({ job_id: applicant?.job_id })),
//         dispatch(
//           getApplicationStatusHistory({ id: applicant?.application_id })
//         ),
//       ]);
//       setOpenSelectModal(false);
//       setRemarks("");
//     } catch (error) {
//       console.error("Error updating status:", error);
//     }
//   };

//   const isPreviousRoundSelected = (rounds, currentIndex) => {
//     if (currentIndex === 0) return true;
//     return rounds[currentIndex - 1]?.selection_status === "Selected";
//   };

//   const allRoundsSelected =
//     rounds?.length > 0 &&
//     rounds.every(
//       (round) => !round.scheduled || round.selection_status === "Selected"
//     );

//   const RoundCard = ({ round, index }) => {
//     const currentTime = new Date();
//     const cutoffTime =
//       round.type === "Assignment"
//         ? new Date(round.deadline)
//         : round.interview_schedule?.end_time
//         ? new Date(round.interview_schedule.end_time)
//         : new Date();

//     const isTimeEnded = currentTime > cutoffTime;
//     const isActive = isPreviousRoundSelected(rounds, index);
//     const showActionButtons =
//       round.scheduled && !round.selection_status && isTimeEnded;

//     return (
//       <Box
//         sx={{
//           mb: 2,
//           p: 2,
//           borderRadius: "8px",
//           border: "1px solid #e0e0e0",
//           backgroundColor: round.scheduled ? "#f5f5f5" : "#E3F2FD",
//           opacity: isActive ? 1 : 0.7,
//           transition: "all 0.3s ease",
//           "&:hover": {
//             boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//             borderColor: "#0044C6",
//           },
//         }}
//       >
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             gap: 1,
//           }}
//         >
//           <Typography variant="subtitle1" fontWeight="bold" color="#0044C6">
//             {round.name}
//           </Typography>
//           <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//             {round.selection_status && (
//               <Typography
//                 sx={{
//                   color:
//                     round.selection_status === "Selected" ? "green" : "red",
//                 }}
//               >
//                 {round.selection_status}
//               </Typography>
//             )}
//             {round.scheduled &&
//               !round.selection_status &&
//               !openDelete &&
//               !showActionButtons && (
//                 <>
//                   <IconButton
//                     onClick={() => handleScheduleClick(round)}
//                     size="small"
//                     disabled={!isActive}
//                   >
//                     <EditRoundedIcon fontSize="small" />
//                   </IconButton>
//                   <IconButton
//                     onClick={() => handleDeleteRound(round.round_code)}
//                     size="small"
//                     disabled={!isActive}
//                   >
//                     <DeleteRoundedIcon fontSize="small" />
//                   </IconButton>
//                 </>
//               )}
//           </Box>
//         </Box>

//         <Typography variant="body2" sx={{ color: "#666", mt: 0.5 }}>
//           Type: {round.type === "F2F" ? "Face to Face" : round.type}
//         </Typography>

//         {round.scheduled && (
//           <RoundDetails round={round} handleViewDoc={handleViewDoc} />
//         )}

//         {showActionButtons && (
//           <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
//             <Button
//               variant="contained"
//               fullWidth
//               color="error"
//               onClick={() => handleReject(round.round_code)}
//               disabled={!isActive}
//             >
//               Reject
//             </Button>
//             <Button
//               variant="contained"
//               fullWidth
//               sx={{ bgcolor: "#0044C6" }}
//               onClick={() => handleSelect(round.round_code)}
//               disabled={!isActive}
//             >
//               Select
//             </Button>
//           </Box>
//         )}

//         {!round.scheduled && (
//           <Button
//             variant="contained"
//             fullWidth
//             sx={{ mt: 2, bgcolor: "#0044C6" }}
//             onClick={() => handleScheduleClick()}
//           >
//             Schedule Round
//           </Button>
//         )}
//       </Box>
//     );
//   };

//   return (
//     <Box sx={{ width: "100%", maxWidth: 800, mx: "auto", p: 1 }}>
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           mb: 3,
//         }}
//       >
//         <Typography variant="h6">Interview Rounds</Typography>
//         {allRoundsSelected && rounds?.some((round) => round.scheduled) && (
//           <>
//             <Button variant="outlined" onClick={() => setOpenSelectModal(true)}>
//               Mark as Interviewed
//             </Button>
//             <SelectModal
//               open={openSelectModal}
//               onClose={() => setOpenSelectModal(false)}
//               remarks={remarks}
//               setRemarks={setRemarks}
//               onConfirm={handleFinalInterviewed}
//             />
//           </>
//         )}
//       </Box>

//       <Box sx={{ flex: 1, overflowY: "auto", px: 1 }}>
//         {rounds?.map((round, index) => (
//           <RoundCard key={round?.id} round={round} index={index} />
//         ))}
//       </Box>

//       <Button
//         variant="contained"
//         fullWidth
//         sx={{ bgcolor: "#0044C6" }}
//         onClick={() => handleScheduleClick()} // Pass no argument for new round
//         disabled={
//           rounds?.length > 0 && !rounds[rounds?.length - 1]?.selection_status
//         }
//       >
//         {rounds?.length === 0
//           ? "Add First Interview Round"
//           : "Add New Interview Round"}
//       </Button>

//       <SelectionModal
//         open={openSelectModal}
//         onClose={() => setOpenSelectModal(false)}
//         remarks={remarks}
//         setRemarks={setRemarks}
//         onConfirm={handleFinalInterviewed}
//       />

//       <RejectionModal
//         open={openRejectModal}
//         onClose={() => setOpenRejectModal(false)}
//         remarks={remarks}
//         setRemarks={setRemarks}
//         onConfirm={handleConfirmReject}
//       />

//       <DeleteConfirmationDialog
//         open={openDelete}
//         onClose={() => setOpenDelete(false)}
//         onConfirm={handleConfirmDelete}
//       />

//       {/* Add BusySlotModal */}
//       <BusySlotModal
//         open={showBusySlotModal}
//         onClose={() => setShowBusySlotModal(false)}
//         slots={selectedDateBusySlots}
//         date={selectedDate}
//         onScheduleAnyway={() => {
//           // This will be handled by the InterviewScheduleSlider
//           setShowBusySlotModal(false);
//         }}
//       />

//       <AssignmentModal
//         viewType={viewType}
//         openPdf={openPdf}
//         onClose={() => setPdfOpen(false)}
//         application_id={selectedAssignment?.application_id}
//         assignment_file={selectedAssignment?.assignment_file}
//         assignment_file_type={selectedAssignment?.assignment_file_type}
//         submission_file={selectedAssignment?.submission_file}
//         submission_file_type={selectedAssignment?.submission_file_type}
//       />

//       <InterviewScheduleSlider
//         open={scheduleModalOpen}
//         onClose={() => setScheduleModalOpen(false)}
//         candidateId={candidateId}
//         existingRound={editingRound?.round_code}
//         isEditMode={!!editingRound}
//         applicant={applicant}
//       />
//     </Box>
//   );
// };

const InterviewRoundsList = ({ candidateId, applicant, onStatusUpdate }) => {
  const dispatch = useDispatch();
  const [rounds, setRounds] = useState([]);
  const [openSelectModal, setOpenSelectModal] = useState(false);
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [selectedRoundCode, setSelectedRoundCode] = useState(null);
  const [selectedAssignment, setSelectedAssignment] = useState(null);
  const [openPdf, setPdfOpen] = useState(false);
  const [editingRound, setEditingRound] = useState(null);
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [viewType, setViewType] = useState("");

  // Add busy slots state
  const [showBusySlotModal, setShowBusySlotModal] = useState(false);
  const [selectedDateBusySlots, setSelectedDateBusySlots] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const interviewers = useSelector((state) => state?.jobs?.interviewers?.interviewers) || [];
  const Jobs = useSelector((state) => state?.jobs?.postedJobsData) || {};
  const postedJobs = Jobs?.posted_jobs;
  const InterviewRoundsRes = useSelector(
    (state) => state?.jobs?.interviewRounds
  ) || [];
  // console.log("InterviewRoundsRes:", InterviewRoundsRes);
  // Add busy slots selector
  const interviewersbusyslots = useSelector((state) => state?.jobs?.interviewersbusyslots) || {};

  const getNoOfRounds = (applicant, postedJobs) => {
    const job = postedJobs?.find((job) => job?.id === applicant?.job_id);
    return job ? job?.no_of_rounds : null;
  };

  useEffect(() => {
    // const totalRounds = getNoOfRounds(applicant, postedJobs);
    // if (totalRounds) {
    //   const completedRoundsCount = InterviewRoundsRes?.length || 0;
    //   console.log("completedRoundsCount", completedRoundsCount)
    //   const totalRoundsToShow = Math.max(totalRounds, completedRoundsCount);

    //   const initialRounds = Array.from(
    //     { length: totalRoundsToShow },
    //     (_, index) => ({
    //       id: index + 1,
    //       name: `Round ${index + 1}`,
    //       type: "Not Scheduled",
    //       scheduled: false,
    //       status: "Pending",
    //     })
    //   );

    //   const updatedRounds = initialRounds?.map((round, index) => {
    //     const completedRound = InterviewRoundsRes[index];
    //     return completedRound
    //       ? { ...round, ...completedRound, scheduled: true }
    //       : round;
    //   });

    //   setRounds(updatedRounds);
    // }
    const completedRoundsCount = InterviewRoundsRes?.length || 0;
    const jobRounds = getNoOfRounds(applicant, postedJobs);

    // Decide how many rounds we should show: if jobRounds is present use that,
    // otherwise fall back to the number of rounds we actually received (or at least 1).
    let totalRoundsToShow = 1;
    if (jobRounds && jobRounds > 0) {
      totalRoundsToShow = Math.max(jobRounds, completedRoundsCount);
    } else if (completedRoundsCount > 0) {
      totalRoundsToShow = completedRoundsCount;
    }

    const initialRounds = Array.from(
      { length: totalRoundsToShow },
      (_, index) => ({
        id: index + 1,
        name: `Round ${index + 1}`,
        type: "Not Scheduled",
        scheduled: false,
        status: "Pending",
      })
    );

    // If we have jobRounds, overlay them with InterviewRoundsRes; if not, prefer the actual rounds received.
    let updatedRounds;
    if (jobRounds && jobRounds > 0) {
      updatedRounds = initialRounds.map((round, index) => {
        const completedRound = InterviewRoundsRes?.[index];
        return completedRound
          ? { ...round, ...completedRound, scheduled: true }
          : round;
      });
    } else {
      // No job configured rounds, use the InterviewRoundsRes as-is (map to keep fields consistent)
      updatedRounds = InterviewRoundsRes?.map((r, idx) => ({
        id: idx + 1,
        name: r?.name || `Round ${idx + 1}`,
        ...r,
        scheduled: true,
      })) || initialRounds;
    }

    setRounds(updatedRounds);
  }, [InterviewRoundsRes, applicant, postedJobs]);

  useEffect(() => {
    if (candidateId) {
      dispatch(getInterviewRounds(candidateId));
    }
  }, [candidateId, dispatch]);

  // Add busy slots detection function (from InterviewScheduleSlider)
  const getBusySlots = (date) => {
    if (!interviewersbusyslots || !date) return [];

    const dateStr = dayjs(date).format("YYYY-MM-DD");
    const busySlots = [];

    Object.entries(interviewersbusyslots).forEach(([email, slots]) => {
      const interviewer = interviewers?.find((i) => i.email === email);
      slots.forEach((slot) => {
        const slotDate = dayjs(slot.start).format("YYYY-MM-DD");
        if (slotDate === dateStr) {
          busySlots.push({
            interviewer: {
              name: `${interviewer?.first_name} ${interviewer?.last_name}`,
              email,
              avatar: interviewer?.profile_url,
            },
            start: dayjs(slot.start),
            end: dayjs(slot.end),
          });
        }
      });
    });

    return busySlots.sort((a, b) => a.start.valueOf() - b.start.valueOf());
  };

  const handleSelect = (roundCode) => {
    setSelectedRoundCode(roundCode);
    setOpenSelectModal(true);
  };

  const handleReject = (roundCode) => {
    setSelectedRoundCode(roundCode);
    setOpenRejectModal(true);
  };

  // const handleConfirmSelect = () => {
  //   dispatch(
  //     changeInterviewStatus({
  //       round_code: selectedRoundCode,
  //       selection_status: "Selected",
  //       remarks: remarks,
  //     })
  //   ).then(() => {
  //     // Update the specific round status only
  //     setRounds((prev) =>
  //       prev.map((round) =>
  //         round.round_code === selectedRoundCode
  //           ? { ...round, selection_status: "Selected" }
  //           : round
  //       )
  //     );
  //     setOpenSelectModal(false);
  //     setRemarks("");
  //     setSelectedRoundCode(null);
  //   });
  // };

  const handleConfirmSelect = () => {
    console.log("handleConfirmSelect", candidateId)
    const Res = dispatch(
      changeInterviewStatus({
        round_code: selectedRoundCode,
        selection_status: "Selected",
        remarks: remarks,
      })
    ).then(() => {
      // Update the specific round status only
      setRounds((prev) =>
        prev.map((round) =>
          round.round_code === selectedRoundCode
            ? { ...round, selection_status: "Selected" }
            : round
        )
      );
      setOpenSelectModal(false);
      setRemarks("");
      setSelectedRoundCode(null);
      dispatch(getInterviewRounds(candidateId));
      // NEW: refresh rounds in store so other components update
      if (candidateId) {
        dispatch(getInterviewRounds(candidateId));
        dispatch(getApplicationStatusHistory({ id: applicant?.application_id }));
        setOpenRejectModal(false);
      }
    });
  };


  // const handleConfirmReject = () => {
  //   dispatch(
  //     changeInterviewStatus({
  //       round_code: selectedRoundCode,
  //       selection_status: "Rejected",
  //       remarks: remarks,
  //     })
  //   ).then(() => {
  //     // Update the specific round status only
  //     setRounds((prev) =>
  //       prev.map((round) =>
  //         round.round_code === selectedRoundCode
  //           ? { ...round, selection_status: "Rejected" }
  //           : round
  //       )
  //     );
  //     setOpenRejectModal(false);
  //     setRemarks("");
  //     setSelectedRoundCode(null);
  //   });
  // };

  const handleConfirmReject = () => {
    console.log("IAM TOP function")
    dispatch(
      changeInterviewStatus({
        round_code: selectedRoundCode,
        selection_status: "Rejected",
        remarks: remarks,
      })
    ).then(() => {
      // Update the specific round status only
      setRounds((prev) =>
        prev.map((round) =>
          round.round_code === selectedRoundCode
            ? { ...round, selection_status: "Rejected" }
            : round
        )
      );
      setOpenRejectModal(false);
      setRemarks("");
      setSelectedRoundCode(null);
      // NEW: refresh rounds in store so other components update
      console.log("IAM Outside function")
      if (candidateId) {
        console.log("IAM Inside function")
        dispatch(getInterviewRounds(candidateId));
        dispatch(getApplicationStatusHistory({ id: applicant?.application_id }));
        setOpenRejectModal(false);
      }
    });
  };


  const handleScheduleClick = (roundToEdit = null) => {
    setEditingRound(roundToEdit);
    setScheduleModalOpen(true);
  };

  const handleDeleteRound = (roundCode) => {
    setSelectedRoundCode(roundCode);
    setOpenDelete(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await dispatch(deleteRond(selectedRoundCode));
      dispatch(getInterviewRounds(candidateId));
      setOpenDelete(false);
      setSelectedRoundCode(null);
    } catch (error) {
      console.error("Delete round failed:", error);
    }
  };

  const handleViewDoc = (round, type) => {
    setSelectedAssignment(round);
    setViewType(type);
    setPdfOpen(true);
  };

  const handleFinalInterviewed = async () => {
    const payload = {
      application_id: applicant?.application_id,
      status: "Selected",
      remarks: remarks || "Candidate completed all rounds successfully",
    };

    try {
      const res = await dispatch(changeJobApplicationStatus(payload));

      await Promise.all([

        dispatch(getApplicants({ job_id: applicant?.job_id })),
        dispatch(getApplicationStatusHistory({ id: applicant?.application_id })),
      ]);
      onStatusUpdate?.("Selected")
      setOpenSelectModal(false);
      setRemarks("");
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const isPreviousRoundSelected = (rounds, currentIndex) => {
    if (currentIndex === 0) return true;
    return rounds[currentIndex - 1]?.selection_status === "Selected";
  };

  const allRoundsSelected =
    rounds?.length > 0 &&
    rounds.every(
      (round) => !round.scheduled || round.selection_status === "Selected"
    );

  const RoundCard = ({ round, index }) => {
    const currentTime = new Date();
    const cutoffTime =
      round.type === "Assignment"
        ? new Date(round.deadline)
        : round.interview_schedule?.end_time
          ? new Date(round.interview_schedule.end_time)
          : new Date();

    const isTimeEnded = currentTime > cutoffTime;
    const isActive = isPreviousRoundSelected(rounds, index);
    const showActionButtons =
      round.scheduled && !round.selection_status && isTimeEnded;

    return (
      <Box
        sx={{
          mb: 2,
          p: 2,
          borderRadius: "8px",
          border: "1px solid #e0e0e0",
          backgroundColor: round.scheduled ? "#f5f5f5" : "#E3F2FD",
          opacity: isActive ? 1 : 0.7,
          transition: "all 0.3s ease",
          "&:hover": {
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            borderColor: "#0044C6",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Typography variant="subtitle1" fontWeight="bold" color="#0044C6">
            {round.name}
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            {round.selection_status && (
              <Typography
                sx={{
                  color:
                    round.selection_status === "Selected" ? "green" : "red",
                }}
              >
                {round.selection_status}
              </Typography>
            )}
            {round.scheduled &&
              !round.selection_status &&
              !openDelete &&
              !showActionButtons && (
                <>
                  <IconButton
                    onClick={() => handleScheduleClick(round)}
                    size="small"
                    disabled={!isActive}
                  >
                    <EditRoundedIcon fontSize="small" />
                  </IconButton>
                  <IconButton
                    onClick={() => handleDeleteRound(round.round_code)}
                    size="small"
                    disabled={!isActive}
                  >
                    <DeleteRoundedIcon fontSize="small" />
                  </IconButton>
                </>
              )}
          </Box>
        </Box>

        <Typography variant="body2" sx={{ color: "#666", mt: 0.5 }}>
          Type: {round.type === "F2F" ? "Face to Face" : round.type}
        </Typography>

        {round.scheduled && (
          <RoundDetails round={round} handleViewDoc={handleViewDoc} />
        )}

        {showActionButtons && (
          <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
            <Button
              variant="contained"
              fullWidth
              color="error"
              onClick={() => handleReject(round.round_code)}
              disabled={!isActive}
            >
              Reject
            </Button>
            <Button
              variant="contained"
              fullWidth
              sx={{ bgcolor: "#0044C6" }}
              onClick={() => handleSelect(round.round_code)}
              disabled={!isActive}
            >
              Select
            </Button>
          </Box>
        )}

        {!round.scheduled && (
          <Button
            variant="contained"
            fullWidth
            sx={{ mt: 2, bgcolor: "#0044C6" }}
            onClick={() => handleScheduleClick()}
          >
            Schedule Round
          </Button>
        )}
      </Box>
    );
  };

  return (
    <Box sx={{ width: "100%", maxWidth: 800, mx: "auto", p: 1 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography variant="h6">Interview Rounds</Typography>
        {allRoundsSelected && rounds?.some((round) => round.scheduled) && (
          <>
            <Button variant="outlined" onClick={() => setOpenSelectModal(true)}>
              Mark as Interviewed
            </Button>
            <SelectModal
              open={openSelectModal}
              onClose={() => setOpenSelectModal(false)}
              remarks={remarks}
              setRemarks={setRemarks}
              onConfirm={handleFinalInterviewed}
            />
          </>
        )}
      </Box>

      <Box sx={{ flex: 1, overflowY: "auto", px: 1 }}>
        {rounds?.map((round, index) => (
          // <RoundCard key={round?.id} round={round} index={index} />
          <RoundCard
            key={round?.round_code || round?.id || index}
            round={round}
            index={index}
          />
        ))}
      </Box>

      <Button
        variant="contained"
        fullWidth
        sx={{ bgcolor: "#0044C6" }}
        onClick={() => handleScheduleClick()} // Pass no argument for new round
        disabled={
          rounds?.length > 0 && !rounds[rounds?.length - 1]?.selection_status
        }
      >
        {rounds?.length === 0
          ? "Add First Interview Round"
          : "Add New Interview Round"}
      </Button>

      {/* Selection Modal for individual rounds */}
      <SelectionModal
        open={openSelectModal && selectedRoundCode}
        onClose={() => {
          setOpenSelectModal(false);
          setSelectedRoundCode(null);
        }}
        remarks={remarks}
        setRemarks={setRemarks}
        onConfirm={handleConfirmSelect}
      />

      {/* Rejection Modal for individual rounds */}
      <RejectionModal
        open={openRejectModal && selectedRoundCode}
        onClose={() => {
          setOpenRejectModal(false);
          setSelectedRoundCode(null);
        }}
        remarks={remarks}
        setRemarks={setRemarks}
        onConfirm={handleConfirmReject}
      />

      {/* Final Interviewed Modal (for marking entire candidate as selected) */}
      <SelectModal
        open={openSelectModal && !selectedRoundCode}
        onClose={() => setOpenSelectModal(false)}
        remarks={remarks}
        setRemarks={setRemarks}
        onConfirm={handleFinalInterviewed}
      />

      <DeleteConfirmationDialog
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        onConfirm={handleConfirmDelete}
      />

      {/* Add BusySlotModal */}
      <BusySlotModal
        open={showBusySlotModal}
        onClose={() => setShowBusySlotModal(false)}
        slots={selectedDateBusySlots}
        date={selectedDate}
        onScheduleAnyway={() => {
          // This will be handled by the InterviewScheduleSlider
          setShowBusySlotModal(false);
        }}
      />

      <AssignmentModal
        viewType={viewType}
        openPdf={openPdf}
        onClose={() => setPdfOpen(false)}
        application_id={selectedAssignment?.application_id}
        assignment_file={selectedAssignment?.assignment_file}
        assignment_file_type={selectedAssignment?.assignment_file_type}
        submission_file={selectedAssignment?.submission_file}
        submission_file_type={selectedAssignment?.submission_file_type}
      />

      <InterviewScheduleSlider
        open={scheduleModalOpen}
        onClose={() => setScheduleModalOpen(false)}
        candidateId={candidateId}
        existingRound={editingRound?.round_code}
        isEditMode={!!editingRound}
        applicant={applicant}
      />
    </Box>
  );
};


const RoundDetails = ({ round, handleViewDoc }) => (
  <>
    {round.type === "F2F" && round.interview_schedule && (
      <>
        <Typography variant="body2" sx={{ color: "#666", mt: 1 }}>
          Date:{" "}
          {new Date(round.interview_schedule.start_time).toLocaleDateString()}
        </Typography>
        <Typography variant="body2" sx={{ color: "#666" }}>
          Time:{" "}
          {new Date(round.interview_schedule.start_time).toLocaleTimeString()} -
          {new Date(round.interview_schedule.end_time).toLocaleTimeString()}
        </Typography>
        <Typography variant="body2" sx={{ color: "#666", mt: 0.5 }}>
          Location: {round.interview_location}
        </Typography>
        <Typography variant="body2" sx={{ color: "#666", mt: 0.5 }}>
          Description: {round?.description}
        </Typography>

        {round?.interviewers_list && (
          <Box sx={{ mt: 2, borderTop: "1px solid #eee", pt: 2 }}>
            <Typography
              variant="body2"
              sx={{ color: "#666", fontWeight: "bold", mb: 1 }}
            >
              Interviewer Details:
            </Typography>
            {round?.interviewers_list?.map((interviewer, idx) => (
              <Box
                key={idx}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  mb: 1,
                  p: 1,
                  borderRadius: "4px",
                  backgroundColor: "rgba(0, 68, 198, 0.05)",
                }}
              >
                <Box
                  component="img"
                  src={
                    interviewer?.profile_url ||
                    "https://static.vecteezy.com/system/resources/thumbnails/009/734/564/small_2x/default-avatar-profile-icon-of-social-media-user-vector.jpg"
                  }
                  alt={`${interviewer?.first_name}'s profile`}
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
                <Box>
                  <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                    {interviewer?.first_name || "User"} {interviewer?.last_name}
                  </Typography>
                  <Typography variant="caption" sx={{ color: "#666" }}>
                    {interviewer?.designation}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        )}
      </>
    )}

    {round.type === "Remote" && round.interview_schedule && (
      <>
        <Typography variant="body2" sx={{ color: "#666", mt: 1 }}>
          Date:{" "}
          {new Date(round.interview_schedule.start_time).toLocaleDateString()}
        </Typography>
        <Typography variant="body2" sx={{ color: "#666" }}>
          Time:{" "}
          {new Date(round.interview_schedule.start_time).toLocaleTimeString()} -
          {new Date(round.interview_schedule.end_time).toLocaleTimeString()}
        </Typography>
        <Typography
          component="a"
          href={round.interview_schedule.meet_link}
          target="_blank"
          sx={{
            display: "flex",
            alignItems: "center",
            color: "#0044C6",
            mt: 1,
          }}
        >
          <InsertLinkRoundedIcon sx={{ mr: 0.5 }} /> Join Meeting
        </Typography>

        {round?.interviewers_list && (
          <Box sx={{ mt: 2, mb: 2, borderTop: "1px solid #eee", pt: 2 }}>
            <Typography
              variant="body2"
              sx={{ color: "#666", fontWeight: "bold", mb: 1 }}
            >
              Interviewer Details:
            </Typography>
            {round?.interviewers_list?.map((interviewer, idx) => (
              <Box
                key={idx}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  mb: 1,
                  p: 1,
                  borderRadius: "4px",
                  backgroundColor: "rgba(0, 68, 198, 0.05)",
                }}
              >
                <Box
                  component="img"
                  src={
                    interviewer?.profile_url ||
                    "https://static.vecteezy.com/system/resources/thumbnails/009/734/564/small_2x/default-avatar-profile-icon-of-social-media-user-vector.jpg"
                  }
                  alt={`${interviewer?.first_name}'s profile`}
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
                <Box>
                  <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                    {interviewer?.first_name || "User"} {interviewer?.last_name}
                  </Typography>
                  <Typography variant="caption" sx={{ color: "#666" }}>
                    {interviewer?.designation}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        )}
        <Typography
          component="a"
          href={round?.interview_schedule?.meet_link}
          target="_blank"
          sx={{
            mt: 1,
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            textDecoration: "none",
            color: "#0044C6",
            "&:hover": { color: "#003399" },
          }}
        >
          <InsertLinkRoundedIcon
            sx={{ color: "#0044C6", marginRight: "5px" }}
          />
          Join Meeting
        </Typography>
      </>
    )}

    {round?.type === "Assignment" && (
      <>
        <Typography variant="body2" sx={{ color: "#666", mt: 1 }}>
          Deadline:{" "}
          {round?.deadline
            ? new Date(round?.deadline).toLocaleString()
            : "No deadline set"}
        </Typography>
        {round?.description && (
          <Typography variant="body2" sx={{ color: "#666", mt: 0.5 }}>
            Description: {round?.description}
          </Typography>
        )}
        {round.assignment_file_type === "application/pdf" ||
          round.assignment_file_type?.startsWith("image/") ? (
          <Typography
            component="a"
            href={round.assignment_file}
            onClick={(e) => {
              e.preventDefault();
              handleViewDoc(round, "Assignment");
            }}
            sx={{
              mt: 1,
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              textDecoration: "none",
              color: "#0044C6",
              "&:hover": { color: "#003399" },
            }}
          >
            <AssignmentRoundedIcon
              sx={{ color: "#0044C6", marginRight: "5px" }}
            />
            View Assignment
          </Typography>
        ) : (
          <Typography
            component="a"
            href={round.assignment_file}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              mt: 1,
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              textDecoration: "none",
              color: "#0044C6",
              "&:hover": { color: "#003399" },
            }}
          >
            <AssignmentRoundedIcon
              sx={{ color: "#0044C6", marginRight: "5px" }}
            />
            Check Assignment
          </Typography>
        )}
      </>
    )}
    <hr />
    {round?.submission_file &&
      (round?.submission_file_type === "application/pdf" ||
        round?.submission_file_type?.startsWith("image/") ? (
        <Typography
          component="a"
          href={round?.submission_file}
          onClick={(e) => {
            e.preventDefault();
            handleViewDoc(round, "submission");
          }}
          sx={{
            mt: 1,
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            textDecoration: "none",
            color: "#0044C6",
            "&:hover": { color: "#003399" },
          }}
        >
          View Submission
        </Typography>
      ) : (
        <Typography
          component="a"
          href={round?.submission_file}
          target="_blank"
          sx={{
            mt: 1,
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            textDecoration: "none",
            color: "#0044C6",
            "&:hover": { color: "#003399" },
          }}
        >
          <AssignmentRoundedIcon
            sx={{ color: "#0044C6", marginRight: "5px" }}
          />
          Download Assignment
        </Typography>
      ))}
  </>
);

export default InterviewRoundsList;